import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';

@Component({
  selector: 'app-subtitle',
  templateUrl: './subtitle.component.html',
  styleUrls: ['./subtitle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubtitleComponent implements OnInit {
  @Input() subtitleText?: string;
  @Input() fontSize?: number;
  @Input() fontFamily?: string;
  @Input() textBotPadding?: number;
  constructor() {}

  ngOnInit(): void {}
}
